import { useRouterState } from "@tanstack/react-router";
import { motion, animate, useMotionValue, useTransform } from "motion/react";
import { useEffect, useState } from "react";

export function TopLoader() {
	const isLoading = useRouterState({ select: (s) => s.isLoading });
	const progress = useMotionValue(0);
	const width = useTransform(progress, (v) => `${v}%`);
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		let cleanup: (() => void) | undefined;

		if (isLoading) {
			setVisible(true);
			progress.set(0);

			const controls = animate(progress, 90, {
				duration: 10,
				ease: [0.25, 0.1, 0.25, 1],
			});

			cleanup = () => controls.stop();
		} else if (visible) {
			const controls = animate(progress, 100, {
				duration: 0.2,
				ease: "easeOut",
				onComplete: () => {
					setTimeout(() => {
						setVisible(false);
						progress.set(0);
					}, 150);
				},
			});

			cleanup = () => controls.stop();
		}

		return cleanup;
	}, [isLoading, progress, visible]);

	if (!visible) return null;

	return (
		<div className="pointer-events-none fixed inset-x-0 top-0 z-[9999] h-0.5">
			<motion.div
				className="h-full bg-primary shadow-[0_0_8px_var(--primary)]"
				style={{ width }}
			/>
		</div>
	);
}
